<mat-dialog-content>

  <div class="mb-0 d-flex justify-content-between">
    <span class="mb-4 page-title">
      {{ "CHANGE_PASSWORD" | translate }}
      <app-page-help-text code="CHANGE_PASSWORD"></app-page-help-text>
    </span>
    <mat-icon class="close-icon text-danger cursor-pointer" (click)="onNoClick()">cancel</mat-icon>
  </div>

  <form [formGroup]="changePasswordForm">
    <div class="d-flex">
      <div class="form-group">
        <label>{{'EMAIL' | translate}}</label>
        <input [attr.disabled]="true" formControlName="email" class="form-control" type="email">
      </div>
    </div>
    <div class="d-flex">
      <div class="form-group">
        <label class="text-danger">{{'CURRENT_PASSWORD' | translate}} *</label>
        <input autocomplete="new-password" formControlName="oldPasswordPassword" class="form-control" type="password">
        @if(changePasswordForm.get('oldPasswordPassword')?.touched &&
        changePasswordForm.get('oldPasswordPassword')?.errors &&
        changePasswordForm.get('oldPasswordPassword')?.errors?.['required']){
        <div class="text-danger">
          {{'CURRENT_PASSWORD_IS_REQUIRED' | translate}}
        </div>
        }
      </div>
    </div>
    <div class="d-flex">
      <div class="form-group">
        <label class="text-danger">{{'NEW_PASSWORD' | translate}} *</label>
        <input autocomplete="new-password" formControlName="password" class="form-control" type="password">
        @if(changePasswordForm.get('password')?.touched && changePasswordForm.get('password')?.errors){
        @if(changePasswordForm.get('password')?.errors?.['required']){
        <div class="text-danger">
          {{'PASSWORD_IS_REQUIRED' | translate}}
        </div>
        }
        @if(changePasswordForm.get('password')?.errors?.['minlength']){
        <div class="text-danger">
          {{'YOU_HAVE_TO_ENTER_AT_LEAST_6_DIGIT' | translate}}
        </div>
        }
        }
      </div>
    </div>
    <div class="d-flex">
      <div class="form-group">
        <label class="text-danger">{{'CONFIRM_PASSWORD' | translate}} *</label>
        <input autocomplete="new-password" formControlName="confirmPassword" class="form-control" type="password">
        @if(changePasswordForm.get('confirmPassword')?.touched &&
        changePasswordForm.get('confirmPassword')?.errors){
        @if(changePasswordForm.get('confirmPassword')?.errors?.['required']){
        <div class="text-danger">
          {{'CONFIRM_PASSWORD_IS_REQUIRED' | translate}}
        </div>
        }
        @if(changePasswordForm.hasError('notSame')){
        <div>
          {{'PASSWORDS_DO_NOT_MATCH' | translate}}
        </div>
        }
        }
      </div>
    </div>
    <div class="mt-3 d-flex" [dir]="langDir">
      <button (click)="changePassword()" class="success me-2" matButton="filled" cdkFocusInitial>
        <mat-icon class="medium-icon fs-5 align-middle">save</mat-icon> {{'SAVE' | translate}}
      </button>
      <button type="button" class="error" matButton="filled" (click)="onNoClick()">
        <mat-icon class="medium-icon fs-5 align-middle">cancel</mat-icon> {{'CANCEL' | translate}}
      </button>
    </div>
  </form>
</mat-dialog-content>